import MegamenuContent from './MegamenuContent';

export default MegamenuContent;
